import { motion, AnimatePresence } from "framer-motion";
import { useBackToClose } from "../../utils/backToClose";

const Modal = ({ show, onClose, title, children, className }) => {
  useBackToClose(show, onClose);
  return (
    <AnimatePresence>
      {show && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose} // close on overlay click
          />

          {/* Modal Content */}
          <motion.div
            className={`fixed inset-0 flex items-center justify-center z-50 p-4 ${className}`}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            <div
              className={`bg-white rounded-xl shadow-xl w-full max-w-4xl p-6 relative `}
            //   onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal
            >
              {/* Header */}
              {title && (
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold">{title}</h3>
                  <button
                    type="button"
                    onClick={onClose}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    ✕
                  </button>
                </div>
              )}

              {/* Body */}
              <div className="">{children}</div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Modal;
